/* KRUZADA · menú móvil, galería, selector de packs y barra de compra fija */
(function () {
  // Menú móvil
  var menu = document.querySelector('[data-kz-menu]');
  var open = document.querySelector('[data-kz-menu-open]');
  var close = document.querySelector('[data-kz-menu-close]');
  if (menu && open && close) {
    open.addEventListener('click', function () { menu.hidden = false; close.focus(); });
    close.addEventListener('click', function () { menu.hidden = true; open.focus(); });
    menu.addEventListener('click', function (e) { if (e.target === menu || e.target.closest('a')) menu.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.hidden = true; });
  }

  // Pop-up de bienvenida: sale a los X segundos de entrar en la tienda (no de cada página) y una vez por visita
  var pop = document.querySelector('[data-kz-popup]');
  if (pop) {
    var read = function (store, key) { try { return window[store].getItem(key); } catch (e) { return null; } };
    var write = function (store, key, value) { try { window[store].setItem(key, value); } catch (e) {} };
    // Desde la fecha de cambio (02-11), el pop-up da el código de después (HOLA10, desde 65 €)
    var switchAt = Date.parse(pop.dataset.switchAt || '');
    if (switchAt && Date.now() >= switchAt && pop.dataset.codeAfter) {
      var after = pop.dataset.codeAfter;
      var codeEl = pop.querySelector('[data-kz-popup-code]');
      var useEl = pop.querySelector('[data-kz-popup-use]');
      var headEl = pop.querySelector('[data-kz-popup-heading]');
      var ticketEl = pop.querySelector('[data-kz-popup-ticket]');
      if (codeEl) codeEl.textContent = after;
      if (useEl) useEl.setAttribute('href', useEl.getAttribute('href').replace('/discount/' + encodeURIComponent(useEl.dataset.code), '/discount/' + encodeURIComponent(after)));
      if (headEl && pop.dataset.titleAfter) headEl.textContent = pop.dataset.titleAfter;
      if (ticketEl && pop.dataset.ticketAfter) ticketEl.textContent = pop.dataset.ticketAfter;
    }
    var steps = Array.prototype.slice.call(pop.querySelectorAll('[data-kz-step]'));
    var lastFocus = null;
    var showStep = function (name) { pop.dataset.step = name; steps.forEach(function (s) { s.hidden = s.dataset.kzStep !== name; }); };
    var openPop = function (name) {
      showStep(name);
      lastFocus = document.activeElement;
      pop.hidden = false;
      document.body.classList.add('kz-popup-open');
      pop.querySelector('[data-kz-popup-close]').focus();
    };
    // Botón "Prueba tu suerte": abajo a la izquierda mientras no haya dejado el correo; su cruz lo oculta en esta visita
    var luck = document.querySelector('[data-kz-luck]');
    var showLuck = function () {
      if (!luck) return;
      luck.hidden = !!read('localStorage', 'kz-popup-done') || !!read('sessionStorage', 'kz-luck-hidden') || !pop.hidden;
    };
    var closePop = function () {
      pop.hidden = true;
      document.body.classList.remove('kz-popup-open');
      write('sessionStorage', 'kz-popup-closed', '1');
      if (lastFocus) lastFocus.focus();
      showLuck();
    };
    if (luck) {
      luck.querySelector('[data-kz-luck-open]').addEventListener('click', function () {
        luck.hidden = true;
        // Si ya eligió placa, vuelve directo a dejar el correo
        openPop(pop.querySelector('.is-picked') ? 'email' : pop.dataset.start);
      });
      luck.querySelector('[data-kz-luck-hide]').addEventListener('click', function () {
        write('sessionStorage', 'kz-luck-hidden', '1');
        luck.hidden = true;
      });
    }
    pop.querySelectorAll('[data-kz-popup-close]').forEach(function (b) { b.addEventListener('click', closePop); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) closePop(); });

    // Las tres placas: la elegida gira, se pone en horizontal y se amplía ocupando el sitio de los textos (todas tienen
    // el mismo descuento). "Reclamar" pasa al correo.
    var tiles = Array.prototype.slice.call(pop.querySelectorAll('[data-kz-tile]'));
    // «La forja» (03-11): fogonazo y chispas de cobre desde la placa elegida
    var forja = function (t) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var box = t.parentNode, br = box.getBoundingClientRect(), tr = t.getBoundingClientRect();
      var x = tr.left - br.left + tr.width / 2, y = tr.top - br.top + tr.height / 2;
      var add = function (cls, vars) {
        var el = document.createElement('span');
        el.className = cls;
        el.setAttribute('aria-hidden', 'true');
        el.style.setProperty('--x', x + 'px');
        el.style.setProperty('--y', y + 'px');
        Object.keys(vars || {}).forEach(function (k) { el.style.setProperty(k, vars[k]); });
        box.appendChild(el);
        window.setTimeout(function () { el.remove(); }, 1600);
      };
      add('kz-forja-flash');
      for (var i = 0; i < 40; i++) {
        var a = Math.random() * Math.PI * 2, d = 80 + Math.random() * 180;
        add('kz-spark', { '--dx': Math.cos(a) * d + 'px', '--dy': Math.sin(a) * d - 30 + 'px', '--s': (3 + Math.random() * 4).toFixed(1) + 'px', '--t': (.9 + Math.random() * .7).toFixed(2) + 's' });
      }
    };
    var claim = pop.querySelector('[data-kz-claim]');
    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        t.classList.add('is-picked');
        t.parentNode.classList.add('is-done');
        forja(t);
        tiles.forEach(function (o) { o.disabled = true; });
        var step = t.closest('[data-kz-step]');
        if (claim) claim.hidden = false;
        void step.offsetWidth;
        step.classList.add('is-revealing');
        // Al acabar el giro, la placa 3D se cambia por una plana a tamaño real: el texto queda nítido
        window.setTimeout(function () { step.classList.add('is-settled'); }, 1150);
        window.setTimeout(function () { if (claim) claim.focus({ preventScroll: true }); }, 1200);
      });
    });
    if (claim) claim.addEventListener('click', function () {
      showStep('email');
      pop.querySelector('[data-kz-popup-email]').focus();
    });

    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function () { write('sessionStorage', 'kz-popup-sent', '1'); });

    var copy = pop.querySelector('[data-kz-popup-copy]');
    if (copy && navigator.clipboard) {
      copy.addEventListener('click', function () {
        navigator.clipboard.writeText(pop.querySelector('[data-kz-popup-code]').textContent.trim());
        copy.textContent = copy.dataset.copied;
      });
    }

    var state = pop.querySelector('[data-kz-popup-state]').dataset.kzPopupState;
    var sent = read('sessionStorage', 'kz-popup-sent');
    // Si lo cierra, no vuelve a salir en esta visita; en la siguiente, sí. Si deja el correo, nunca más
    var resting = !!read('sessionStorage', 'kz-popup-closed');
    if (resting && state !== 'error' && state !== 'done' && !sent) showLuck();
    if (window.Shopify && window.Shopify.designMode) {
      // En el editor de temas solo se abre al seleccionar la sección
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(pop)) openPop(pop.dataset.start); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(pop)) pop.hidden = true; });
    } else if (state === 'error') {
      openPop('email');
    } else if (state === 'done' || sent) {
      try { window.sessionStorage.removeItem('kz-popup-sent'); } catch (e) {}
      write('localStorage', 'kz-popup-done', '1');
      openPop('done');
    } else if (!read('localStorage', 'kz-popup-done') && !resting) {
      var first = Number(read('sessionStorage', 'kz-popup-first') || 0);
      if (!first) { first = Date.now(); write('sessionStorage', 'kz-popup-first', String(first)); }
      var wait = Number(pop.dataset.delay) * 1000 - (Date.now() - first);
      window.setTimeout(function () { if (pop.hidden) openPop(pop.dataset.start); }, Math.max(wait, 1500));
    }
  }

  // Carrito lateral: añadir sin salir de la página, con la foto volando hasta el icono del carrito.
  // El icono del carrito no lo abre: sigue llevando a la página del carrito.
  var drawer = document.querySelector('[data-kz-drawer]');
  if (drawer && window.fetch && window.DOMParser) {
    var DRAWER_ID = 'kz-cart-drawer';
    var drawerFocus = null;
    var openDrawer = function () {
      drawerFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('kz-drawer-open');
      void drawer.offsetWidth; // fuerza el pintado cerrado para que se vea la transición
      drawer.classList.add('is-open');
      var x = drawer.querySelector('.kz-drawer-x');
      if (x) x.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      document.body.classList.remove('kz-drawer-open');
      window.setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 300);
      if (drawerFocus && drawerFocus.focus) drawerFocus.focus();
    };
    var paint = function (html) {
      if (!html) return;
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kz-drawer-content]');
      var current = drawer.querySelector('[data-kz-drawer-content]');
      if (!fresh || !current) return;
      current.replaceWith(fresh);
      document.querySelectorAll('[data-kz-cart-count]').forEach(function (el) { el.textContent = fresh.dataset.count; });
    };
    var asJson = function (r) { if (!r.ok) throw r; return r.json(); };

    // Cambiar cantidades y quitar, dentro del carrito lateral
    var changeLine = function (line, qty) {
      drawer.classList.add('is-busy');
      fetch(drawer.dataset.changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty), sections: DRAWER_ID })
      }).then(asJson)
        .then(function (cart) { paint(cart.sections && cart.sections[DRAWER_ID]); })
        .catch(function () { window.location.href = drawer.querySelector('.kz-drawer-link') ? drawer.querySelector('.kz-drawer-link').href : '/cart'; })
        .then(function () { drawer.classList.remove('is-busy'); });
    };
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-kz-drawer-close]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-kz-qty]');
      if (q) changeLine(q.dataset.kzLine, q.dataset.kzQty);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });

    // La foto del producto que se añade: la visible en la galería de la ficha o la de la tarjeta
    var sourceImage = function (form) {
      var card = form.closest('.product-card, .kz-pair');
      if (card) return card.querySelector('img');
      var track = document.querySelector('[data-kz-gallery]');
      if (track && track.children.length) {
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        var slide = track.children[Math.min(i, track.children.length - 1)];
        return slide.querySelector('img');
      }
      return null;
    };
    var fly = function (img) {
      var cart = document.querySelector('.cart-button');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!img || !cart || calm || !img.animate) return Promise.resolve();
      var a = img.getBoundingClientRect();
      var b = cart.getBoundingClientRect();
      if (!a.width || a.bottom < 0 || a.top > window.innerHeight) return Promise.resolve();
      var size = 96;
      var x0 = a.left + a.width / 2 - size / 2;
      var y0 = a.top + a.height / 2 - size / 2;
      var dx = b.left + b.width / 2 - (x0 + size / 2);
      var dy = b.top + b.height / 2 - (y0 + size / 2);
      var ghost = document.createElement('img');
      ghost.src = img.currentSrc || img.src;
      ghost.alt = '';
      ghost.className = 'kz-fly';
      ghost.style.cssText = 'left:' + x0 + 'px;top:' + y0 + 'px;width:' + size + 'px;height:' + size + 'px';
      document.body.appendChild(ghost);
      var anim = ghost.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.45 + 'px, ' + (dy * 0.45 - 70) + 'px) scale(.65)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(.18)', opacity: 0.5 }
      ], { duration: 800, easing: 'cubic-bezier(.45, 0, .25, 1)' });
      return new Promise(function (done) {
        var ended = false;
        var finish = function () {
          if (ended) return;
          ended = true;
          ghost.remove();
          cart.classList.add('is-bump');
          window.setTimeout(function () { cart.classList.remove('is-bump'); }, 400);
          done();
        };
        anim.onfinish = finish;
        // Seguro: si el navegador congela la animación (pestaña en segundo plano), el carrito se abre igual
        window.setTimeout(finish, 1100);
      });
    };

    // Todos los formularios de añadir al carrito (ficha, barra fija y tarjetas).
    // El botón añade con fetch sin enviar el formulario: Shopify cuenta por separado el "submit" de /cart/add y el
    // fetch a /cart/add.js, y con los dos el AddToCart de Meta salía doble (21-10). El "submit" queda de respaldo (Enter).
    var isAddForm = function (form) { return form && form.matches && form.matches('form[action*="/cart/add"]'); };
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
      if (!btn || btn.disabled || !isAddForm(btn.form)) return;
      e.preventDefault();
      addToCart(btn.form);
    });
    document.addEventListener('submit', function (e) {
      if (!isAddForm(e.target)) return;
      e.preventDefault();
      addToCart(e.target);
    });
    var addToCart = function (form) {
      var buttons = Array.prototype.slice.call(document.querySelectorAll('[type="submit"]')).filter(function (b) { return b.form === form; });
      buttons.forEach(function (b) { b.disabled = true; });
      var data = new FormData(form);
      data.append('sections', DRAWER_ID);
      var request = fetch(drawer.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data }).then(asJson);
      Promise.all([request, fly(sourceImage(form))])
        .then(function (res) { paint(res[0].sections && res[0].sections[DRAWER_ID]); openDrawer(); })
        .catch(function () { form.submit(); })
        .then(function () { buttons.forEach(function (b) { b.disabled = false; }); });
    };
  }

  // Carrusel de reseñas: las flechas avanzan una tarjeta; en móvil se desliza con el dedo
  document.querySelectorAll('[data-kz-carousel]').forEach(function (c) {
    var track = c.querySelector('[data-kz-track]');
    var step = function (dir) {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    var prev = c.querySelector('[data-kz-prev]');
    var next = c.querySelector('[data-kz-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    // Flechas apagadas en los extremos
    var ends = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    track.addEventListener('scroll', function () { window.requestAnimationFrame(ends); }, { passive: true });
    window.addEventListener('resize', ends);
    ends();
  });

  // Seguir mi pedido: resultados de 17TRACK en la propia página
  var trackForm = document.querySelector('[data-kz-track-form]');
  if (trackForm) {
    var trackInput = trackForm.querySelector('[data-kz-track-input]');
    var trackBox = document.querySelector('[data-kz-track-result]');
    var trackError = document.querySelector('[data-kz-track-error]');
    var lang = (document.documentElement.lang || 'es').slice(0, 2);
    var openOutside = function (num) { window.open('https://t.17track.net/' + lang + '#nums=' + encodeURIComponent(num), '_blank', 'noopener'); };
    var loadTracker = function () {
      if (window.YQV5) return Promise.resolve();
      return new Promise(function (ok, fail) {
        var s = document.createElement('script');
        s.src = 'https://www.17track.net/externalcall.js';
        s.onload = ok; s.onerror = fail;
        document.head.appendChild(s);
      });
    };
    var track = function (num) {
      num = num.replace(/\s+/g, '').toUpperCase();
      trackError.hidden = true;
      if (num.length < 6) { trackError.hidden = false; return; }
      loadTracker().then(function () {
        trackBox.hidden = false;
        trackBox.innerHTML = '';
        window.YQV5.trackSingle({ YQ_ContainerId: 'kz-track-result', YQ_Height: 560, YQ_Fc: '0', YQ_Lang: lang, YQ_Num: num });
        trackBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }).catch(function () { openOutside(num); });
    };
    trackForm.addEventListener('submit', function (e) { e.preventDefault(); track(trackInput.value); });
    var pre = new URLSearchParams(window.location.search).get('num');
    if (pre) { trackInput.value = pre; track(pre); }
  }

  var root = document.querySelector('[data-kz-product]');
  if (!root) return;

  // Galería: las miniaturas desplazan el carrusel; el desplazamiento marca la miniatura activa.
  // Cada foto lleva data-packs (vacío = todos los packs); al elegir pack solo quedan las suyas y su foto principal va primero.
  var track = root.querySelector('[data-kz-gallery]');
  var thumbBox = root.querySelector('[data-kz-thumbs]');
  var allSlides = track ? Array.prototype.slice.call(track.children) : [];
  var allThumbs = thumbBox ? Array.prototype.slice.call(thumbBox.children) : [];
  function visibleThumbs() {
    return thumbBox ? Array.prototype.slice.call(thumbBox.children).filter(function (t) { return !t.hidden; }) : [];
  }
  // En ordenador (03-11) las fotos van en columna, una debajo de otra: la miniatura baja la página hasta su foto
  var stacked = function () { return window.matchMedia('(min-width: 701px)').matches; };
  function visibleSlides() { return allSlides.filter(function (s) { return !s.hidden; }); }
  function goTo(index, instant) {
    if (!track) return;
    if (stacked()) {
      var slide = visibleSlides()[index];
      if (slide && !instant) window.scrollTo({ top: slide.getBoundingClientRect().top + window.scrollY - 96, behavior: 'smooth' });
      return;
    }
    track.scrollTo({ left: track.clientWidth * index, behavior: instant ? 'auto' : 'smooth' });
  }
  function markThumb() {
    if (!track) return;
    var i;
    if (stacked()) {
      var mid = window.innerHeight * 0.4;
      i = 0;
      visibleSlides().forEach(function (s, k) { if (s.getBoundingClientRect().top <= mid) i = k; });
    } else {
      i = Math.round(track.scrollLeft / (track.clientWidth || 1));
    }
    visibleThumbs().forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
  }
  window.addEventListener('scroll', function () { if (stacked()) window.requestAnimationFrame(markThumb); }, { passive: true });
  // La columna de compra baja con la página hasta que se ve entera y luego se queda fija mientras se ven las fotos
  var buyCol = root.querySelector('.buy');
  var placeBuy = function () {
    if (!buyCol) return;
    if (!stacked()) { buyCol.style.top = ''; return; }
    buyCol.style.top = Math.min(96, window.innerHeight - buyCol.offsetHeight - 24) + 'px';
  };
  placeBuy();
  window.addEventListener('resize', placeBuy);
  if (window.ResizeObserver && buyCol) new ResizeObserver(placeBuy).observe(buyCol);
  function showPack(key, mainId) {
    if (!track) return;
    // La foto principal de cada pack (data-media-id del botón) solo sale en su pack, sin etiquetar nada.
    var owners = {};
    root.querySelectorAll('[data-kz-pack]').forEach(function (b) {
      if (b.dataset.mediaId) owners[b.dataset.mediaId] = (owners[b.dataset.mediaId] ? owners[b.dataset.mediaId] + ' ' : '') + b.dataset.packKey;
    });
    var fits = function (el) {
      // Foto propia de un pack (bloque Pack, 03-11): solo cuando ese pack está elegido
      if (el.dataset.packMain) return !!key && el.dataset.packs === key;
      var p = ((el.dataset.packs || '') + ' ' + (owners[el.dataset.mediaId] || '')).trim();
      return !p || !key || p.split(/\s+/).indexOf(key) > -1;
    };
    var main = allSlides.filter(function (s) { return s.dataset.packMain && fits(s); })[0] ||
      (mainId ? allSlides.filter(function (s) { return s.dataset.mediaId === mainId && fits(s); })[0] : null);
    var order = allSlides.filter(function (s) { return s !== main; });
    if (main) order.unshift(main);
    // Fotos fijadas (data-kz-pin, p. ej. la de Halloween) van siempre delante
    order = order.filter(function (s) { return s.dataset.kzPin; }).concat(order.filter(function (s) { return !s.dataset.kzPin; }));
    order.forEach(function (s) { s.hidden = !fits(s); track.appendChild(s); });
    if (thumbBox) {
      order.forEach(function (s) {
        var t = allThumbs.filter(function (x) { return x.dataset.key === s.dataset.key; })[0];
        if (t) { t.hidden = s.hidden; thumbBox.appendChild(t); }
      });
      visibleThumbs().forEach(function (t, k) { t.dataset.index = k; });
      thumbBox.hidden = visibleThumbs().length < 2;
      thumbBox.scrollTop = 0;
      thumbBox.scrollLeft = 0;
    }
    goTo(0, true);
    markThumb();
  }
  allThumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      goTo(Number(t.dataset.index));
      visibleThumbs().forEach(function (x) { x.classList.toggle('is-active', x === t); });
    });
  });
  if (track) {
    track.addEventListener('scroll', function () { window.requestAnimationFrame(markThumb); }, { passive: true });
  }

  // Selector de packs: cambia la variante, el precio en todos los sitios y la foto
  var input = root.querySelector('[data-kz-variant-input]');
  var packs = Array.prototype.slice.call(root.querySelectorAll('[data-kz-pack]'));
  var pick = root.querySelector('[data-kz-pick]');
  var pickError = root.querySelector('[data-kz-pick-error]');
  // Sin pack elegido no se añade nada (ni desde el botón, la barra fija o «Combina bien con»): se avisa en el selector
  if (pick && input) {
    var askPick = function (e) {
      if (input.value) return;
      var t = e.target.closest && e.target.closest('button[type="submit"], .kz-pair-add');
      if (e.type === 'click' && !t) return;
      if (e.type === 'click' && !t.classList.contains('kz-pair-add') && t.form !== input.form) return;
      if (e.type === 'submit' && e.target !== input.form) return;
      e.preventDefault();
      e.stopPropagation();
      pick.classList.remove('is-error');
      void pick.offsetWidth;
      pick.classList.add('is-error');
      if (pickError) pickError.hidden = false;
      var r = pick.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight) window.scrollTo({ top: r.top + window.scrollY - 120, behavior: 'smooth' });
    };
    document.addEventListener('click', askPick, true);
    document.addEventListener('submit', askPick, true);
  }
  function select(pack) {
    if (!pack || pack.disabled) return;
    packs.forEach(function (p) {
      var on = p === pack;
      p.classList.toggle('selected', on);
      p.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    if (input) input.value = pack.dataset.variantId;
    // Selección obligatoria (03-11): al elegir se quita el aviso y el botón pasa a llevar el precio
    if (pick) { pick.classList.add('is-done'); pick.classList.remove('is-error'); if (pickError) pickError.hidden = true; }
    var buyLabel = root.querySelector('[data-kz-buy-label]');
    if (buyLabel && pick && !buyLabel.querySelector('[data-kz-price]')) {
      buyLabel.innerHTML = buyLabel.textContent.trim() + ' · <span data-kz-price>' + pack.dataset.price + '</span>';
    }
    document.querySelectorAll('[data-kz-specs-pdf]').forEach(function (a) { a.hidden = a.dataset.kzSpecsPdf !== pack.dataset.variantId; });
    document.querySelectorAll('[data-kz-price]').forEach(function (el) {
      // Precio grande de la ficha en formato «€59,95 EUR» (03-11)
      el.innerHTML = el.hasAttribute('data-kz-price-eur') ? '€' + pack.dataset.price.replace(/\s*€\s*$/, '') + ' EUR' : pack.dataset.price;
      if (el.hasAttribute('data-kz-hw') && pack.dataset.cents) el.setAttribute('data-kz-hw', pack.dataset.cents);
    });
    if (window.kzHwPaint) window.kzHwPaint(); // oferta Halloween (snippet kz-hw-oferta)
    if (pack.dataset.half) document.querySelectorAll('[data-kz-half]').forEach(function (el) { el.textContent = pack.dataset.half; });
    document.querySelectorAll('[data-kz-title]').forEach(function (el) { el.textContent = pack.dataset.title; });
    showPack(pack.dataset.packKey, pack.dataset.mediaId);
    var url = new URL(window.location.href);
    if (pick) url.searchParams.delete('variant'); // selección obligatoria: al recargar vuelve a no haber pack
    else url.searchParams.set('variant', pack.dataset.variantId);
    window.history.replaceState({}, '', url);
  }
  packs.forEach(function (p) { p.addEventListener('click', function () { select(p); }); });
  var startPack = packs.filter(function (p) { return p.classList.contains('selected'); })[0];
  if (startPack) showPack(startPack.dataset.packKey, startPack.dataset.mediaId);
  else showPack('', null);

  // Botones "Elegir" de la tabla comparativa
  document.querySelectorAll('[data-kz-choose]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pack = packs.find(function (p) { return p.dataset.variantId === btn.dataset.kzChoose; });
      select(pack);
      var buy = document.getElementById('compra');
      if (buy) buy.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // Barra de compra fija en móvil: solo cuando el botón principal sale de la pantalla
  var buyBtn = root.querySelector('[data-kz-buy]');
  var sticky = root.querySelector('[data-kz-sticky]');
  if (buyBtn && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.hidden = entries[0].isIntersecting;
    }, { threshold: 0 }).observe(buyBtn);
  }
})();

/* Más opiniones: carga las reseñas del JSON del tema y las va mostrando por tandas */
(function () {
  var grid = document.querySelector('[data-kz-allrev]');
  if (!grid) return;
  var btn = document.querySelector('[data-kz-allrev-more]');
  var page = Number(grid.dataset.page) || 5;
  var first = Number(grid.dataset.first) || 9;
  var shown = 0;
  var list = [];
  function esc(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }
  function card(r) {
    var rating = Math.max(1, Math.min(5, Number(r.rating) || 5));
    var imgs = Array.isArray(r.images) ? r.images : [];
    var html = '<article class="kz-allrev-card">';
    if (imgs.length) {
      html += '<div class="kz-allrev-img"><img src="' + esc(imgs[0]) + '" alt="" loading="lazy">' +
        (imgs.length > 1 ? '<span>+' + (imgs.length - 1) + '</span>' : '') + '</div>';
    }
    html += '<div class="kz-allrev-body">' +
      '<p class="kz-allrev-name">' + esc(r.author) + (r.verified ? '<em>✓ ' + esc(grid.dataset.verified) + '</em>' : '') + '</p>' +
      (r.date ? '<p class="kz-allrev-date">' + esc(r.date) + '</p>' : '') +
      '<p class="kz-allrev-stars" role="img" aria-label="' + rating + '/5">' + '★'.repeat(rating) + (rating < 5 ? '<i>' + '★'.repeat(5 - rating) + '</i>' : '') + '</p>' +
      '<p class="kz-allrev-text" data-kz-review-text data-original="' + esc(r.text) + '"' + (r.text_en ? ' data-en="' + esc(r.text_en) + '"' : '') + '>' + esc(r.text) + '</p>' +
      (r.text_en && grid.dataset.translate ? '<button type="button" class="kz-review-translate" data-kz-review-translate data-label-tr="' + esc(grid.dataset.translate) + '" data-label-orig="' + esc(grid.dataset.original) + '">' + esc(grid.dataset.translate) + '</button>' : '') +
      '</div></article>';
    return html;
  }
  function more() {
    var next = list.slice(shown, shown + (shown ? page : first));
    grid.insertAdjacentHTML('beforeend', next.map(card).join(''));
    shown += next.length;
    if (btn) btn.hidden = !list.length; // el botón se queda aunque ya no haya más
  }
  if (btn) btn.addEventListener('click', more);
  fetch(grid.dataset.src)
    .then(function (r) { return r.json(); })
    .then(function (data) { list = Array.isArray(data) ? data : []; more(); })
    .catch(function () { grid.closest('.kz-allrev').hidden = true; });
})();

/* Fecha de entrega: {fecha} en las líneas de confianza = hoy + N días, en el idioma de la página */
(function () {
  var lang = document.documentElement.lang || 'es';
  document.querySelectorAll('[data-kz-eta]').forEach(function (el) {
    var d = new Date();
    d.setDate(d.getDate() + (Number(el.dataset.days) || 20));
    try {
      var opts = el.dataset.format === 'long' ? { weekday: 'long', day: 'numeric', month: 'long' } : { day: 'numeric', month: 'long' };
      el.textContent = d.toLocaleDateString(lang, opts);
    } catch (e) {
      el.textContent = d.getDate() + '/' + (d.getMonth() + 1);
    }
  });
})();

/* Cupones del carrito: un clic añade o quita el código; el del 10 % solo se ve si dejó el correo en el pop-up */
(function () {
  var emailDone = false;
  try { emailDone = !!window.localStorage.getItem('kz-popup-done'); } catch (e) {}
  var showEmail = function () {
    // Desde la fecha de cambio (02-11), el cupón del correo pasa a ser el de después (HOLA10, desde 65 €)
    document.querySelectorAll('[data-kz-coupon-email][data-switch-at]').forEach(function (b) {
      var at = Date.parse(b.dataset.switchAt);
      if (!at || Date.now() < at || b.dataset.kzCoupon === b.dataset.codeAfter) return;
      b.dataset.kzCoupon = b.dataset.codeAfter;
      var c = b.querySelector('[data-kz-coupon-code]');
      var l = b.querySelector('[data-kz-coupon-label]');
      if (c) c.textContent = b.dataset.codeAfter;
      if (l && b.dataset.labelAfter) l.textContent = b.dataset.labelAfter;
    });
    if (!emailDone) return;
    document.querySelectorAll('[data-kz-coupon-email][hidden]').forEach(function (b) { b.hidden = false; });
  };
  showEmail();

  // El estado real de los códigos sale de /cart.js (Liquid no lo sabe: ver snippets/kz-coupons.liquid)
  var money = function (cents) {
    return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  var render = function (cart) {
    var codes = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
    document.querySelectorAll('[data-kz-coupons]').forEach(function (box) {
      box.dataset.applied = codes.join(',');
      box.dataset.synced = '1';
      box.classList.remove('is-busy');
      box.querySelectorAll('[data-kz-coupon]').forEach(function (b) {
        var on = codes.indexOf(b.dataset.kzCoupon) > -1;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) b.hidden = false;
      });
    });
    document.querySelectorAll('[data-kz-ship-line]').forEach(function (l) {
      l.classList.toggle('is-free', codes.indexOf(l.dataset.kzShipLine) > -1);
    });
    document.querySelectorAll('[data-kz-subtotal]').forEach(function (s) { s.textContent = money(cart.total_price); });
    document.querySelectorAll('[data-kz-total]').forEach(function (t) {
      var free = codes.indexOf(t.dataset.shipCode) > -1;
      t.textContent = money(cart.total_price + (free ? 0 : Number(t.dataset.ship || 0)));
    });
    // Precio de cada línea: tachado + precio con descuento + etiqueta (p. ej. "−10 %") si hay un código aplicado.
    // Los descuentos del pedido entero se reparten entre las líneas según su precio, como hace Shopify.
    var apps = (cart.cart_level_discount_applications || []).slice();
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application) apps.push(a.discount_application); });
    });
    var labelOf = function (d) {
      if (!d) return '';
      if (d.type !== 'discount_code' && d.title) return d.title;
      return d.value_type === 'percentage' ? '−' + parseFloat(d.value) + ' %' : (d.title || d.key || '');
    };
    var cartApps = cart.cart_level_discount_applications || [];
    var label = labelOf(cartApps[0] || apps[0]);
    var cartOff = (cart.cart_level_discount_applications || []).reduce(function (a, d) { return a + (d.total_allocated_amount || 0); }, 0);
    var base = (cart.items || []).reduce(function (a, it) { return a + it.final_line_price; }, 0);
    document.querySelectorAll('[data-kz-line-price]').forEach(function (el) {
      var it = cart.items[Number(el.dataset.kzLinePrice)];
      if (!it) return;
      var share = base ? Math.round(cartOff * it.final_line_price / base) : 0;
      var now = it.final_line_price - share;
      var orig = it.original_line_price;
      el.innerHTML = now < orig
        ? '<s>' + money(orig) + '</s><strong>' + money(now) + '</strong>' + (function () {
            var own = (it.line_level_discount_allocations || []).filter(function (a) { return a.amount > 0; })[0];
            var l = own ? labelOf(own.discount_application) + (cartApps.length ? ' · ' + labelOf(cartApps[0]) : '') : label;
            return l ? '<span class="kz-line-off">' + l + '</span>' : '';
          })()
        : '<strong>' + money(it.final_line_price) + '</strong>';
    });
  };
  var sync = function () {
    if (!document.querySelector('[data-kz-coupons]')) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  };
  sync();
  // El carrito lateral se vuelve a pintar entero: enseñar otra vez el cupón del correo y el estado de los códigos
  new MutationObserver(function () {
    showEmail();
    if (document.querySelector('[data-kz-coupons]:not([data-synced])')) sync();
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kz-coupon]');
    if (!btn) return;
    var box = btn.closest('[data-kz-coupons]');
    var codes = (box.dataset.applied || '').split(',').filter(Boolean);
    var code = btn.dataset.kzCoupon;
    var i = codes.indexOf(code);
    if (i > -1) codes.splice(i, 1); else codes.push(code);
    // Si quita el envío gratis a mano, no se le vuelve a poner solo; si lo vuelve a marcar, sí
    if (!btn.hasAttribute('data-kz-coupon-email')) {
      try { if (i > -1) window.localStorage.setItem('kz-ship-off', '1'); else window.localStorage.removeItem('kz-ship-off'); } catch (e) {}
    }
    // Respuesta inmediata; si falla, la vuelve a dejar como estaba
    btn.classList.toggle('is-on', i === -1);
    box.classList.add('is-busy');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      // La respuesta de /cart/update.js no trae el reparto de los descuentos: se relee /cart.js
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(render)
      .catch(function () { window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart'; });
  });
})();

/* Página del carrito: cantidades con − / +, papelera por línea y "Vaciar cesta" (con confirmación en el mismo botón) */
(function () {
  var page = document.querySelector('[data-kz-cart-page]');
  var form = page && page.querySelector('form');
  if (!form || !window.fetch) return;
  page.classList.add('is-js');
  var post = function (url, body) {
    page.classList.add('is-busy');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  };
  var reload = function () { window.location.reload(); };
  var change = function (line, qty) {
    post('/cart/change.js', { line: Number(line), quantity: Number(qty) }).then(reload).catch(function () {
      var up = form.querySelector('[name="update"]');
      if (up) up.click(); else reload();
    });
  };
  page.addEventListener('click', function (e) {
    var step = e.target.closest('[data-kz-step]');
    if (step) {
      var input = step.parentNode.querySelector('input');
      var qty = Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.kzStep));
      input.value = qty;
      if (qty === 0) step.closest('li').classList.add('is-leaving');
      change(input.dataset.kzLine, qty);
      return;
    }
    var trash = e.target.closest('[data-kz-remove]');
    if (trash) {
      e.preventDefault();
      trash.closest('li').classList.add('is-leaving');
      change(trash.dataset.kzRemove, 0);
      return;
    }
    var clear = e.target.closest('[data-kz-cart-clear]');
    if (clear) {
      var label = clear.querySelector('span');
      if (!clear.classList.contains('is-confirm')) {
        clear.classList.add('is-confirm');
        label.textContent = clear.dataset.confirm;
        window.setTimeout(function () { clear.classList.remove('is-confirm'); label.textContent = clear.dataset.label; }, 4000);
        return;
      }
      page.querySelectorAll('.kz-cart-items li').forEach(function (li) { li.classList.add('is-leaving'); });
      post('/cart/clear.js', {}).then(reload).catch(reload);
    }
  });
  page.addEventListener('change', function (e) {
    var input = e.target.closest('input[data-kz-line]');
    if (input) change(input.dataset.kzLine, Math.max(0, parseInt(input.value, 10) || 0));
  });
  // Enter en una cantidad no debe ir al pago (el primer botón del formulario es "Finalizar compra")
  page.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('input[data-kz-line]')) { e.preventDefault(); e.target.blur(); }
  });
})();

/* Barra de aviso rotativa: cambia sola, se para al pasar el ratón y tiene flechas */
(function () {
  var bar = document.querySelector('[data-kz-notice]');
  if (!bar) return;
  var items = Array.prototype.slice.call(bar.querySelectorAll('[data-kz-notice-item]'));
  if (items.length < 2) { bar.classList.add('is-single'); return; }
  var i = 0;
  var speed = (Number(bar.dataset.speed) || 5) * 1000;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var show = function (n) {
    items[i].classList.remove('is-active');
    i = (n + items.length) % items.length;
    items[i].classList.add('is-active');
  };
  var timer = null;
  var start = function () { if (!calm) { stop(); timer = window.setInterval(function () { show(i + 1); }, speed); } };
  var stop = function () { if (timer) window.clearInterval(timer); timer = null; };
  bar.querySelector('[data-kz-notice-prev]').addEventListener('click', function () { show(i - 1); start(); });
  bar.querySelector('[data-kz-notice-next]').addEventListener('click', function () { show(i + 1); start(); });
  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', start);
  start();
})();

/* Reseñas: botón Traducir / Ver original (solo fuera del español) */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-kz-review-translate]');
  if (!btn) return;
  var box = btn.parentElement.querySelector('[data-kz-review-text]');
  if (!box || !box.dataset.en) return;
  var quoted = box.tagName === 'BLOCKQUOTE';
  var showing = box.dataset.showing === 'en';
  var txt = showing ? box.dataset.original : box.dataset.en;
  box.textContent = quoted ? '“' + txt + '”' : txt;
  box.dataset.showing = showing ? 'es' : 'en';
  btn.textContent = showing ? btn.dataset.labelTr : btn.dataset.labelOrig;
});

/* Contador de oferta: cuenta atrás hasta una fecha fija (hora de España); al llegar a cero desaparece */
(function () {
  var box = document.querySelector('[data-kz-countdown]');
  if (!box) return;
  var raw = (box.dataset.end || '').trim().replace(' ', 'T');
  if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) {
    // Sin zona: se toma como hora de España (CET/CEST según la fecha)
    var probe = new Date(raw + 'Z');
    var month = probe.getUTCMonth();
    raw += (month > 2 && month < 10) ? '+02:00' : '+01:00';
  }
  var end = new Date(raw).getTime();
  if (isNaN(end)) return;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var set = function (k, v) { var el = box.querySelector('[data-kz-cd="' + k + '"]'); if (el) el.textContent = pad(v); };
  var tick = function () {
    var left = Math.floor((end - Date.now()) / 1000);
    if (left <= 0) { box.hidden = true; return false; }
    var d = Math.floor(left / 86400);
    box.querySelector('[data-kz-cd-wrap="d"]').hidden = d === 0;
    set('d', d); set('h', Math.floor(left % 86400 / 3600)); set('m', Math.floor(left % 3600 / 60)); set('s', left % 60);
    box.hidden = false;
    return true;
  };
  if (tick()) { var t = window.setInterval(function () { if (!tick()) window.clearInterval(t); }, 1000); }
})();

/* Cabecera: se esconde al bajar; vuelve al subir o cuando la página se queda quieta 0,5 s */
(function () {
  var bar = document.getElementById('shopify-section-kz-header');
  if (!bar) return;
  var notice = bar.querySelector('.notice');
  var measure = function () { bar.style.setProperty('--kz-notice-h', (notice ? notice.offsetHeight : 0) + 'px'); };
  measure();
  window.addEventListener('resize', measure);
  var lastY = window.scrollY;
  var idle = null;
  var show = function () { bar.classList.remove('is-hidden'); };
  var busy = function () {
    var menu = document.querySelector('[data-kz-menu]');
    return document.body.classList.contains('kz-drawer-open') || (menu && !menu.hidden);
  };
  var top = function () { bar.classList.toggle('is-top', window.scrollY < 12); };
  top();
  var update = function () {
    var y = window.scrollY;
    top();
    var d = y - lastY;
    if (y < bar.offsetHeight + 40 || busy()) show();
    else if (d > 6) bar.classList.add('is-hidden');
    else if (d < -4) show();
    lastY = y;
  };
  window.addEventListener('scroll', function () {
    update();
    window.clearTimeout(idle);
    idle = window.setTimeout(show, 500);
  }, { passive: true });
  bar.addEventListener('focusin', show);
})();

/* Seguir mi pedido (Track123): traduce al español los eventos del transportista (24-10). El plan gratuito de Track123
   no los traduce ni publica HTML propio. Fuente y lista de frases: 04-marca-tienda/web/track123/traduccion-eventos.html */
(function () {
  if (window.location.pathname.indexOf('/apps/track123') === -1) return;
  var lang = (document.documentElement.lang || 'es').toLowerCase();
  if (lang.indexOf('es') !== 0) return;
  var T = [
    ['Warehouse is processing this order. Please wait in patience.', 'El almacén está preparando tu pedido.'],
    ['Customs clearance agent received the shipment in destnation country.', 'El agente de aduanas del país de destino ha recibido el envío.'],
    ['Customs clearance agent received the shipment in destination country.', 'El agente de aduanas del país de destino ha recibido el envío.'],
    ["it'sprogressing through delivery network", 'avanza por la red de reparto'],
    ["it's progressing through delivery network", 'avanza por la red de reparto'],
    ['Package has left the carrier facility', 'el paquete ha salido del centro del transportista'],
    ['Package arrived at the carrier facility', 'el paquete ha llegado al centro del transportista'],
    ['Shipment arrived at facility and measured.', 'el paquete ha llegado al centro y se ha medido.'],
    ['Depart from facility to service provider.', 'sale hacia el siguiente transportista.'],
    ['Departed from departure country/region', 'Ha salido del país de origen'],
    ['Departure from the original airport', 'ha salido del aeropuerto de origen'],
    ['Arrived in transit country/region', 'Ha llegado a un país de tránsito'],
    ['Arrive at overseas processing center', 'ha llegado al centro de tratamiento internacional'],
    ['Arrived at destination country/region', 'Ha llegado al país de destino'],
    ['Arrived at departure transport hub', 'Ha llegado al centro de salida'],
    ['Leaving from departure country/region', 'Saliendo del país de origen'],
    ['Arrival to the destination airport', 'ha llegado al aeropuerto de destino'],
    ['Arrived at linehaul office', 'Ha llegado a la oficina de transporte'],
    ['Released from customs', 'liberado por la aduana'],
    ['customs cleared.', 'aduana superada.'],
    ['Hand over to airline', 'entregado a la aerolínea'],
    ['Import customs clearance complete', 'Despacho de aduanas completado'],
    ['Customs clearance completed', 'Despacho de aduanas completado'],
    ['Customs clearance complete', 'Despacho de aduanas completado'],
    ['Arrived at customs', 'En aduanas'],
    ['Received by local delivery company', 'Recibido por la empresa de reparto local'],
    ['Received by logistics company', 'Recibido por la empresa de transporte'],
    ['Processing at sorting center', 'En el centro de clasificación'],
    ['Departed from sorting center', 'Ha salido del centro de clasificación'],
    ['Parcel information received', 'información del paquete recibida'],
    ['Shipment info received', 'Datos del envío recibidos'],
    ['Shipment on the way', 'Envío en camino'],
    ['Shipment picked up.', 'paquete recogido.'],
    ['Package picked up', 'paquete recogido'],
    ['Delivery attempt failed', 'Intento de entrega fallido'],
    ['Delivery attempted', 'Intento de entrega'],
    ['Available for pickup', 'Disponible para recoger'],
    ['Ready for pickup', 'Listo para recoger'],
    ['Returned to sender', 'Devuelto al remitente'],
    ['Out for delivery', 'En reparto'],
    ['Carrier update', 'Actualización del transportista'],
    ['Label created', 'Etiqueta creada'],
    ['In transit', 'en tránsito'],
    ['Delivered', 'Entregado'],
    ['Exception', 'Incidencia']
  ];
  var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
  var R = T.map(function (p) { return [new RegExp(esc(p[0]), 'gi'), p[1]]; });
  var cap = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };
  var translate = function (text) {
    var place = '';
    // "Getafe,ES,[ES,Getafe,N/A] ..." → "Getafe (ES) · ..."
    text = text.replace(/^\s*([^,\[\]]+),([A-Z]{2}),\[[^\]]*\]\s*/, function (m, city, cc) { place = city + ' (' + cc + ') · '; return ''; });
    R.forEach(function (r) { text = text.replace(r[0], r[1]); });
    var parts = text.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var out = cap(parts.shift() || '');
    if (parts.length) out += ': ' + parts.join(', ');
    return place + out;
  };
  var run = function () {
    document.querySelectorAll('.track123_track_desc:not([data-kz-es])').forEach(function (el) {
      el.setAttribute('data-kz-es', '1');
      el.setAttribute('title', el.textContent.trim());
      el.textContent = translate(el.textContent);
    });
  };
  run();
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();

/* Seguir mi pedido (Track123), 31-10: Track123 pone «En tránsito» en cuanto CJ crea la etiqueta, aunque el paquete
   siga en el almacén. Mientras los únicos eventos sean «etiqueta creada / el almacén está preparando tu pedido»,
   el título pasa a «Preparando tu pedido» y la barra se queda en el paso 2 (Pedido preparado). Con el primer
   movimiento real del transportista, Track123 vuelve a mandar. */
(function () {
  if (window.location.pathname.indexOf('/apps/track123') === -1) return;
  var en = (document.documentElement.lang || 'es').toLowerCase().indexOf('en') === 0;
  var WAIT = /label created|etiqueta creada|warehouse is processing|almac[eé]n est[aá] preparando|info(rmation)? received|pending/i;
  var fix = function () {
    var title = document.querySelector('.track123_order_status');
    if (!title || title.getAttribute('data-kz-prep')) return;
    var evs = Array.prototype.slice.call(document.querySelectorAll('.track123_track_desc:not(.track123_order_tracking_details_first_msg)'));
    if (!evs.length) return;
    var waiting = evs.every(function (el) { return WAIT.test((el.getAttribute('title') || '') + ' ' + el.textContent); });
    if (!waiting) return;
    var steps = document.querySelectorAll('.track123_order_step_line1_container');
    if (steps.length < 5) return;
    title.setAttribute('data-kz-prep', '1');
    title.textContent = en ? 'Preparing your order' : 'Preparando tu pedido';
    // Paso 3 (En tránsito) y siguientes: sin rellenar ni fecha; la línea del 2 al 3, vacía
    for (var i = 2; i < steps.length; i++) {
      var dot = steps[i].querySelector('.track123_order_step_line1_process_dot');
      if (dot) dot.style.display = 'none';
      var name = steps[i].querySelector('.track123_order_step_line_status_name');
      if (name) name.classList.add('track123_no_active_status_name');
      var date = steps[i].querySelector('.track123_order_step_line_time');
      if (date) date.textContent = '';
    }
    var line = steps[1].querySelector('.track123_order_step_line1_process');
    if (line) { line.style.width = '0px'; line.style.background = 'transparent'; }
  };
  fix();
  new MutationObserver(fix).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

/* Complementos del carrito: cambiar de modelo y añadir (en la página recarga; en el lateral lo vuelve a pintar) */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-kz-upsell-variant]');
    if (!sel) return;
    var card = sel.closest('[data-kz-upsell]');
    var opt = sel.options[sel.selectedIndex];
    card.querySelector('[data-kz-upsell-add]').dataset.variant = sel.value;
    card.querySelector('[data-kz-upsell-price]').textContent = opt.dataset.price;
    var halfEl = card.querySelector('[data-kz-upsell-half]');
    if (halfEl && opt.dataset.half) halfEl.textContent = opt.dataset.half;
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kz-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('is-busy');
    var inDrawer = !!btn.closest('[data-kz-drawer]');
    var body = { items: [{ id: Number(btn.dataset.variant), quantity: 1 }] };
    if (inDrawer) body.sections = 'kz-cart-drawer';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (res) {
        var html = inDrawer && res.sections && res.sections['kz-cart-drawer'];
        var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('[data-kz-drawer-content]');
        var current = document.querySelector('[data-kz-drawer] [data-kz-drawer-content]');
        if (fresh && current) {
          current.replaceWith(fresh);
          document.querySelectorAll('[data-kz-cart-count]').forEach(function (el) { el.textContent = fresh.dataset.count; });
        } else {
          window.location.reload();
        }
      })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-busy'); });
  });
})();

/* Ficha de un complemento: compra solo con la Tótem en el carrito. Liquid ya lo pinta; aquí se confirma con /cart.js
   porque la página puede venir de la caché de Shopify con otro carrito. */
(function () {
  var ex = document.querySelector('[data-kz-extra]');
  if (!ex || !window.fetch) return;
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
    var locked = !(cart.items || []).some(function (i) { return i.handle === ex.dataset.main; });
    var available = ex.dataset.available === 'true';
    var buy = document.querySelector('[data-kz-buy]');
    var label = buy && buy.querySelector('[data-kz-buy-label]');
    var sticky = document.querySelector('[data-kz-sticky] button');
    ex.classList.toggle('is-locked', locked);
    if (buy) buy.disabled = locked || !available;
    if (label) { if (locked) label.textContent = ex.dataset.lockLabel; else if (available) label.innerHTML = ex.dataset.addLabel; }
    if (sticky) { sticky.disabled = locked || !available; sticky.textContent = locked ? ex.dataset.lockLabel : ex.dataset.addShort; }
  }).catch(function () {});
})();


/* Política de devoluciones (27-10): coloca el resumen bajo el título, pliega los apartados en móvil y añade "Copiar"
   al formulario de desistimiento (el último apartado). Solo actúa si existe [data-kz-refund]. */
(function () {
  var sum = document.querySelector('[data-kz-refund]');
  var cont = document.querySelector('.shopify-policy__container');
  if (!sum || !cont) return;
  var title = cont.querySelector('.shopify-policy__title');
  if (title) title.insertAdjacentElement('afterend', sum);
  var rte = cont.querySelector('.shopify-policy__body .rte');
  if (!rte) return;
  var lang = (document.documentElement.lang || 'es').slice(0, 2);
  var copyTxt = lang === 'en' ? ['Copy the form', 'Copied'] : ['Copiar el formulario', 'Copiado'];
  var heads = Array.prototype.slice.call(rte.querySelectorAll(':scope > h3'));
  var last = heads[heads.length - 1];
  if (last && last.nextElementSibling && last.nextElementSibling.tagName === 'P') {
    var form = last.nextElementSibling;
    form.classList.add('kz-policy-form');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kz-policy-copy';
    btn.textContent = copyTxt[0];
    btn.addEventListener('click', function () {
      var t = form.innerText;
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () {
        btn.textContent = copyTxt[1];
        setTimeout(function () { btn.textContent = copyTxt[0]; }, 2000);
      }).catch(function () {});
    });
    form.insertAdjacentElement('afterend', btn);
  }
  if (!window.matchMedia('(max-width: 760px)').matches) return;
  heads.forEach(function (h) {
    var d = document.createElement('details');
    d.className = 'kz-policy-fold';
    var s = document.createElement('summary');
    var body = document.createElement('div');
    var n = h.nextElementSibling;
    while (n && n.tagName !== 'H3') { var next = n.nextElementSibling; body.appendChild(n); n = next; }
    h.parentNode.insertBefore(d, h);
    s.appendChild(h);
    d.appendChild(s);
    d.appendChild(body);
  });
})();

/* Barra fina de progreso de lectura (27-10) */
(function () {
  var bar = document.querySelector('[data-kz-progress]');
  if (!bar) return;
  var ticking = false;
  var update = function () {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(window.scrollY / max, 1) : 0) + ')';
    ticking = false;
  };
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

/* Reseñas en vídeo (27-10): reproducir sin sonido al entrar en pantalla; botón de sonido */
(function () {
  var vids = document.querySelectorAll('[data-kz-vreview]');
  if (!vids.length) return;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { io.observe(v); });
  }
  document.querySelectorAll('[data-kz-vreview-sound]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.parentElement.querySelector('video');
      if (!v) return;
      var on = v.muted;
      vids.forEach(function (o) { o.muted = true; });
      document.querySelectorAll('[data-kz-vreview-sound]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      v.muted = !on;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  });
})();

/* Antes / después (27-10): arrastrar la franja (ratón o dedo) o usar las flechas con el teclado */
(function () {
  document.querySelectorAll('[data-kz-compare]').forEach(function (box) {
    var range = box.querySelector('.kz-compare-range');
    var dragging = false;
    var start = parseFloat(box.getAttribute('data-start')) || 50;
    function set(p) {
      p = Math.max(0, Math.min(100, p));
      box.style.setProperty('--pos', p + '%');
      if (range) range.value = Math.round(p);
    }
    function fromEvent(e) {
      var r = box.getBoundingClientRect();
      set((e.clientX - r.left) / r.width * 100);
    }
    box.addEventListener('pointerdown', function (e) {
      dragging = true;
      box.classList.add('is-dragging');
      if (box.setPointerCapture) box.setPointerCapture(e.pointerId);
      fromEvent(e);
    });
    box.addEventListener('pointermove', function (e) { if (dragging) fromEvent(e); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      box.addEventListener(t, function () { dragging = false; box.classList.remove('is-dragging'); });
    });
    if (range) range.addEventListener('input', function () { set(+range.value); });
    /* Pista: la franja se mueve sola un poco la primera vez que se ve */
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = null;
        function step(t) {
          if (dragging) return;
          if (t0 === null) t0 = t;
          /* va hacia el otro lado (enseña la mano "sin") y vuelve a la posición inicial */
          var k = Math.min(1, (t - t0) / 2400);
          var far = start < 50 ? 78 : 22;
          set(start + (far - start) * Math.sin(k * Math.PI) * Math.sin(k * Math.PI));
          if (k < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.6 });
      io.observe(box);
    }
  });
})();

/* «Combina bien con» (02-11): puntos del carrusel, pack de la Tótem al día y, si la Tótem ya está en el carrito,
   el botón añade solo el complemento. */
(function () {
  var box = document.querySelector('[data-kz-pairs]');
  if (!box) return;
  var layout = box.closest('.product-layout');
  if (layout) layout.classList.add('has-pairs');
  var track = box.querySelector('[data-kz-pairs-track]');
  var dots = Array.prototype.slice.call(box.querySelectorAll('[data-kz-pairs-dots] button'));
  // Flechas laterales (solo se ven en ordenador): pasan de uno en uno y vuelven al principio al llegar al final
  var go = function (dir) {
    var n = track.children.length, i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    var next = (i + dir + n) % n;
    track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
  };
  var prev = box.querySelector('[data-kz-pairs-prev]'), nextBtn = box.querySelector('[data-kz-pairs-next]');
  if (prev) prev.addEventListener('click', function () { go(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });
  dots.forEach(function (d, i) {
    d.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
  });
  track.addEventListener('scroll', function () {
    var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
  }, { passive: true });
  // Antes de añadir (fase de captura, va antes que el carrito lateral): el pack de la Tótem es el elegido arriba
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.kz-pair-add');
    if (!btn) return;
    var main = document.querySelector('[data-kz-variant-input]');
    var input = btn.form.querySelector('input[name="items[][id]"][data-kz-pair-main]');
    if (main && input) input.value = main.value;
  }, true);
  // Al elegir opción (imanes, diseño) se cambia el precio de la tarjeta (03-11)
  box.querySelectorAll('[data-kz-pair-variant]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex], pr = sel.form.querySelector('[data-kz-pair-price]');
      if (!o || !pr || !o.dataset.b) return;
      var b = pr.querySelector('b'), st = pr.querySelector('s');
      if (b) b.textContent = o.dataset.b;
      if (st && o.dataset.s) st.textContent = o.dataset.s;
    });
  });
  if (!window.fetch) return;
  var sync = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var has = (cart.items || []).some(function (i) { return i.handle === box.dataset.main; });
      box.querySelectorAll('[data-kz-pair-form]').forEach(function (f) {
        var btn = f.querySelector('.kz-pair-add');
        f.querySelectorAll('[data-kz-pair-main]').forEach(function (el) { el.disabled = has; });
        btn.textContent = has ? btn.dataset.add : btn.dataset.addWith;
      });
    }).catch(function () {});
  };
  sync();
  // Tras añadir algo (la Tótem o un complemento), el carrito cambia: se vuelve a mirar
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('button[type="submit"], [data-kz-drawer] button')) window.setTimeout(sync, 1800);
  });
})();

/* Envío gratis de bienvenida activo por defecto (03-11). Al entrar en cualquier página se deja puesto en el carrito el
   código BIENVENIDA (Shopify lo guarda aunque el carrito esté vacío y lo activa al añadir algo). En el pago, Shopify
   comprueba que sea la primera compra y una sola vez por cliente. Si el cliente lo quita a mano en el carrito, no se le
   vuelve a poner. */
(function () {
  var CODE = 'BIENVENIDA';
  if (!window.fetch) return;
  try { if (window.localStorage.getItem('kz-ship-off')) return; } catch (e) {}
  fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
    var codes = (cart.discount_codes || []).map(function (d) { return String(d.code).toUpperCase(); });
    if (codes.indexOf(CODE) > -1) return;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.concat(CODE).join(',') })
    });
  }).catch(function () {});
})();
